export interface Movie {
  id: string;
  title: string;
  category: string;
  categoryName: string;
  year: number;
  rating: number;
  poster: string;
  description: string;
  director: string;
  actors: string[];
  duration: string;
  releaseDate: string;
  isHot: boolean;
  isNew: boolean;
}

export const categories = [
  { slug: 'all', name: '全部' },
  { slug: 'dongzuo', name: '动作' },
  { slug: 'xiju', name: '喜剧' },
  { slug: 'kehuan', name: '科幻' },
  { slug: 'aiqing', name: '爱情' },
  { slug: 'kongbu', name: '恐怖' },
  { slug: 'donghua', name: '动画' },
  { slug: 'xuanyi', name: '悬疑' },
  { slug: 'juqing', name: '剧情' },
];

export const movies: Movie[] = [
  {
    id: '1',
    title: '暗夜追踪',
    category: 'dongzuo',
    categoryName: '动作',
    year: 2026,
    rating: 8.7,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20action%20movie%20poster%20dark%20night%20city%20chase%20scene%20dramatic%20lighting%20intense%20male%20protagonist%20in%20black%20coat%20running%20through%20neon-lit%20streets%20cinematic%20film%20poster%20style%20clean%20background%20with%20warm%20and%20cool%20tones&width=600&height=900&seq=movie-01&orientation=portrait',
    description: '一名退役特种兵在深夜的城市街头意外卷入一场国际阴谋。他必须在24小时内追踪神秘的幕后黑手，在城市暗影中展开一场惊心动魄的追逐战。步步惊心、环环相扣，每一次靠近真相都伴随着致命的危险。当昔日战友变成敌人，他能否在黎明前揭开真相？本片以紧凑的叙事节奏和极具冲击力的动作场面，为观众呈现一场视觉与心灵的双重震撼。',
    director: '陈凯明',
    actors: ['张力宏', '吴振宇', '林雪儿', '黄志伟'],
    duration: '128分钟',
    releaseDate: '2026-06-15',
    isHot: true,
    isNew: true,
  },
  {
    id: '2',
    title: '星际迷途',
    category: 'kehuan',
    categoryName: '科幻',
    year: 2026,
    rating: 9.1,
    poster: 'https://readdy.ai/api/search-image?query=futuristic%20sci-fi%20movie%20poster%20astronaut%20floating%20in%20deep%20space%20stunning%20nebula%20colors%20behind%20spaceship%20silhouette%20cinematic%20film%20poster%20dramatic%20composition%20dark%20background%20with%20vibrant%20cosmic%20hues&width=600&height=900&seq=movie-02&orientation=portrait',
    description: '公元2157年，人类星际移民舰队在穿越仙女座星云时遭遇未知能量场，整支舰队被卷入时空裂缝。舰长李远航带领船员们在陌生的星系中挣扎求生，却意外发现了远古外星文明留下的终极秘密。当生存与使命发生冲突，每个人都将做出改变人类命运的选择。影片以宏大的太空视觉和深刻的哲学思考，重新定义了华语科幻电影的边界。',
    director: '周星辰',
    actors: ['刘浩宇', '张静初', '王大陆', '赵又廷'],
    duration: '145分钟',
    releaseDate: '2026-07-01',
    isHot: true,
    isNew: true,
  },
  {
    id: '3',
    title: '笑傲江湖之风云再起',
    category: 'xiju',
    categoryName: '喜剧',
    year: 2026,
    rating: 8.3,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20comedy%20movie%20poster%20three%20friends%20laughing%20in%20traditional%20martial%20arts%20costumes%20bright%20colorful%20background%20playful%20expressions%20warm%20lighting%20cinematic%20film%20poster%20style&width=600&height=900&seq=movie-03&orientation=portrait',
    description: '三个不靠谱的江湖小人物误打误撞成为了武林盟主的候选人。在一系列啼笑皆非的选拔考验中，他们用智慧和幽默化解了一场武林浩劫。没有盖世武功，只有三寸不烂之舌和一颗赤诚之心。当真正的危机来临时，这三个"冒牌大侠"却展现出了比武功更强大的力量——友情与勇气。',
    director: '徐鸿飞',
    actors: ['沈腾跃', '马丽华', '艾伦明', '魏翔宇'],
    duration: '112分钟',
    releaseDate: '2026-05-28',
    isHot: true,
    isNew: false,
  },
  {
    id: '4',
    title: '那年夏天的秘密',
    category: 'aiqing',
    categoryName: '爱情',
    year: 2026,
    rating: 8.5,
    poster: 'https://readdy.ai/api/search-image?query=romantic%20Chinese%20movie%20poster%20young%20couple%20under%20cherry%20blossom%20trees%20summer%20golden%20hour%20warm%20sunlight%20soft%20focus%20dreamy%20atmosphere%20cinematic%20film%20poster%20style%20gentle%20colors&width=600&height=900&seq=movie-04&orientation=portrait',
    description: '高中毕业的那个夏天，林小曼在老家阁楼上发现了一本尘封的日记。日记的主人是一个素未谋面的男孩，他用文字记录了对她长达三年的暗恋。带着好奇和感动，林小曼开始追寻日记中的每一个细节，却发现命运早已为他们安排了一场最美好的相遇。这是一段关于青春、错过与重逢的温暖故事。',
    director: '陈思怡',
    actors: ['周冬雨', '刘浩然', '赵今麦', '易烊千玺'],
    duration: '108分钟',
    releaseDate: '2026-04-12',
    isHot: false,
    isNew: false,
  },
  {
    id: '5',
    title: '幽灵病房',
    category: 'kongbu',
    categoryName: '恐怖',
    year: 2026,
    rating: 7.9,
    poster: 'https://readdy.ai/api/search-image?query=horror%20movie%20poster%20abandoned%20hospital%20corridor%20dim%20greenish%20lighting%20mysterious%20shadow%20figure%20at%20end%20of%20hallway%20cold%20atmosphere%20cinematic%20film%20poster%20style%20dark%20ominous%20tone&width=600&height=900&seq=movie-05&orientation=portrait',
    description: '年轻医生苏婉清进入一家废弃多年的传染病医院进行医学研究，却在第一晚就遇到了无法解释的超自然现象。每当午夜钟声敲响，走廊尽头就会出现一个穿着病号服的小女孩。随着调查的深入，一段被掩盖了三十年的医疗丑闻逐渐浮出水面。真相远比幽灵更加可怕，而有些秘密，注定不能重见天日。',
    director: '温子涵',
    actors: ['杨紫琼', '彭于晏', '舒淇文', '张震宇'],
    duration: '98分钟',
    releaseDate: '2026-03-20',
    isHot: false,
    isNew: false,
  },
  {
    id: '6',
    title: '深海奇缘',
    category: 'donghua',
    categoryName: '动画',
    year: 2026,
    rating: 9.0,
    poster: 'https://readdy.ai/api/search-image?query=animated%20movie%20poster%20beautiful%20underwater%20world%20colorful%20coral%20reef%20friendly%20sea%20creatures%20young%20girl%20swimming%20with%20dolphins%20magical%20light%20rays%20from%20surface%20vibrant%20colors%20cinematic%20style&width=600&height=900&seq=movie-06&orientation=portrait',
    description: '十岁的小女孩阿兰在一次海边玩耍时救下了一只受伤的海豚，从此获得了一种神奇的能力——与海洋生物对话。她跟随海豚潜入深海，发现了一个隐藏在海底的奇幻王国。但王国的平衡正被人类的污染所破坏，阿兰必须联合海洋伙伴们，在陆地和海洋之间架起一座理解与守护的桥梁。',
    director: '田晓鹏',
    actors: ['张子枫(配音)', '黄渤(配音)', '周迅(配音)', '陈坤(配音)'],
    duration: '102分钟',
    releaseDate: '2026-06-01',
    isHot: true,
    isNew: true,
  },
  {
    id: '7',
    title: '完美嫌疑人',
    category: 'xuanyi',
    categoryName: '悬疑',
    year: 2026,
    rating: 8.8,
    poster: 'https://readdy.ai/api/search-image?query=suspense%20thriller%20movie%20poster%20detective%20holding%20magnifying%20glass%20shadowy%20alley%20rainy%20night%20noir%20lighting%20mysterious%20silhouette%20in%20background%20cinematic%20film%20poster%20style%20dark%20moody%20atmosphere&width=600&height=900&seq=movie-07&orientation=portrait',
    description: '连环命案震惊全城，所有证据都指向了完美的不在场证明。刑警队长顾晨光发现，每一起案件的嫌疑人都拥有铁一般的不在场证明，但所有证据又确凿地指向同一个人。随着调查推进，他陷入了一个精心设计的逻辑陷阱——完美的犯罪背后，隐藏着一个更加骇人的真相。不到最后一刻，你永远不会知道谁是真正的凶手。',
    director: '曹保平',
    actors: ['段奕宏', '王千源', '秦海璐', '张译'],
    duration: '118分钟',
    releaseDate: '2026-02-14',
    isHot: false,
    isNew: false,
  },
  {
    id: '8',
    title: '山河故人',
    category: 'juqing',
    categoryName: '剧情',
    year: 2026,
    rating: 9.2,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20drama%20movie%20poster%20elderly%20couple%20standing%20on%20mountain%20overlooking%20vast%20landscape%20golden%20sunset%20nostalgic%20warm%20tones%20cinematic%20film%20poster%20style%20emotional%20deep%20composition&width=600&height=900&seq=movie-08&orientation=portrait',
    description: '一段跨越六十年的情感史诗。从战火纷飞的年代到和平繁荣的今天，两个家族三代人的命运在时代的洪流中交织碰撞。当老一辈的山盟海誓被岁月冲刷，新一代在迷茫中寻找自我，故乡的山水成为每个漂泊灵魂最终的归宿。影片以磅礴大气的叙事和细腻真挚的情感，描绘了一幅中国社会变迁的壮丽画卷。',
    director: '贾樟柯',
    actors: ['赵涛', '廖凡', '周冬雨', '陈建斌'],
    duration: '138分钟',
    releaseDate: '2026-01-25',
    isHot: false,
    isNew: false,
  },
  {
    id: '9',
    title: '铁拳风云',
    category: 'dongzuo',
    categoryName: '动作',
    year: 2026,
    rating: 8.4,
    poster: 'https://readdy.ai/api/search-image?query=martial%20arts%20movie%20poster%20fighter%20in%20boxing%20ring%20dramatic%20overhead%20lighting%20sweat%20and%20determination%20intense%20expression%20warm%20amber%20spotlight%20cinematic%20film%20poster%20style%20gritty%20atmosphere&width=600&height=900&seq=movie-09&orientation=portrait',
    description: '地下拳手方铁生为了给重病的女儿筹集医药费，不得不重返他曾经发誓要离开的非法搏击场。每一场比赛都可能是他的最后一场，但他不能倒下。当昔日恩师成为幕后的操盘手，当兄弟情义被金钱腐蚀，方铁生必须在拳台上用最原始的方式，为自己和女儿杀出一条血路。',
    director: '林超贤',
    actors: ['吴京', '张晋', '蒋璐霞', '任达华'],
    duration: '122分钟',
    releaseDate: '2026-05-10',
    isHot: true,
    isNew: false,
  },
  {
    id: '10',
    title: '时间裂缝',
    category: 'kehuan',
    categoryName: '科幻',
    year: 2026,
    rating: 8.6,
    poster: 'https://readdy.ai/api/search-image?query=sci-fi%20movie%20poster%20time%20portal%20swirling%20vortex%20street%20scene%20split%20between%20past%20and%20future%20clock%20motif%20dramatic%20lighting%20cinematic%20film%20poster%20style%20surreal%20atmosphere&width=600&height=900&seq=movie-10&orientation=portrait',
    description: '物理学家陈默在一次实验中意外打开了一道时间裂缝，他发现可以通过这道裂缝与三天前的自己进行交流。一开始只是微小的信息传递，但随着操作的深入，时间线开始出现不可逆转的蝴蝶效应。当他试图挽回一场悲剧时，却引发了更为严重的连锁反应。时间可以被改变，但代价是什么？',
    director: '郭帆',
    actors: ['黄渤', '邓超', '佟丽娅', '雷佳音'],
    duration: '132分钟',
    releaseDate: '2026-06-20',
    isHot: true,
    isNew: true,
  },
  {
    id: '11',
    title: '囧途人生',
    category: 'xiju',
    categoryName: '喜剧',
    year: 2025,
    rating: 7.8,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20road%20trip%20comedy%20movie%20poster%20man%20with%20suitcase%20stranded%20in%20rural%20village%20chaotic%20funny%20scene%20bright%20daylight%20warm%20colors%20cinematic%20film%20poster%20style&width=600&height=900&seq=movie-11&orientation=portrait',
    description: '大城市白领因一张错买的火车票，阴差阳错地踏上了一场横跨半个中国的荒诞旅程。从繁华都市到偏远山村，从五星酒店到农家土炕，他在路上遇到了形形色色的人物和意想不到的挑战。原本只想去三亚度假的他，却在旅途中重新找到了生活的意义和久违的快乐。',
    director: '徐峥',
    actors: ['徐峥', '王宝强', '黄渤', '马丽'],
    duration: '110分钟',
    releaseDate: '2025-12-18',
    isHot: false,
    isNew: false,
  },
  {
    id: '12',
    title: '恋恋风尘',
    category: 'aiqing',
    categoryName: '爱情',
    year: 2025,
    rating: 8.2,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20romance%20movie%20poster%20couple%20walking%20on%20autumn%20street%20falling%20leaves%20soft%20evening%20light%20nostalgic%20warm%20tones%20cinematic%20film%20poster%20style%20vintage%20aesthetic&width=600&height=900&seq=movie-12&orientation=portrait',
    description: '在大理古城的小巷里，失意的音乐人遇见了开咖啡馆的女孩。他们在苍山洱海之间，用音乐和咖啡写下了最纯粹的浪漫故事。但现实的阻隔让两个来自不同世界的人面临着艰难的选择。当梦想与爱情不能两全，他们能否在大理的风花雪月中找到属于自己的答案？',
    director: '张一白',
    actors: ['井柏然', '周冬雨', '春夏', '金城武'],
    duration: '105分钟',
    releaseDate: '2025-08-08',
    isHot: false,
    isNew: false,
  },
  {
    id: '13',
    title: '午夜凶铃：重生',
    category: 'kongbu',
    categoryName: '恐怖',
    year: 2025,
    rating: 7.5,
    poster: 'https://readdy.ai/api/search-image?query=horror%20movie%20poster%20old%20television%20with%20static%20snow%20dark%20room%20long%20black%20hair%20emerging%20from%20screen%20cold%20blueish%20lighting%20cinematic%20film%20poster%20style%20terrifying%20atmosphere&width=600&height=900&seq=movie-13&orientation=portrait',
    description: '一卷神秘的录像带重新出现在互联网上，凡是观看过的人都会在七天后离奇死亡。大学生网络社团的成员们为了揭开诅咒的真相，追踪到了录像带的源头——一座被遗忘的精神病院。在那里，他们发现了一段更加黑暗的历史，而真正的恐怖才刚刚开始。',
    director: '温子涵',
    actors: ['李心洁', '张家辉', '杨丞琳', '陈法蓉'],
    duration: '95分钟',
    releaseDate: '2025-10-31',
    isHot: false,
    isNew: false,
  },
  {
    id: '14',
    title: '熊猫特工队',
    category: 'donghua',
    categoryName: '动画',
    year: 2025,
    rating: 8.0,
    poster: 'https://readdy.ai/api/search-image?query=animated%20movie%20poster%20cute%20panda%20wearing%20spy%20gear%20action%20pose%20bamboo%20forest%20background%20playful%20colors%20cinematic%20film%20poster%20style%20family%20friendly&width=600&height=900&seq=movie-14&orientation=portrait',
    description: '四只来自四川大熊猫基地的熊猫宝宝，因为一次意外获得了超能力，被招募为动物特工队的新成员。他们的第一个任务就是阻止邪恶博士用他的"记忆消除器"让全世界忘记保护动物。在这场充满欢笑和冒险的旅程中，四只熊猫学会了团结和勇敢的真正含义。',
    director: '饺子',
    actors: ['杨幂(配音)', '陈赫(配音)', '贾玲(配音)', '沈腾(配音)'],
    duration: '95分钟',
    releaseDate: '2025-06-01',
    isHot: false,
    isNew: false,
  },
  {
    id: '15',
    title: '迷局',
    category: 'xuanyi',
    categoryName: '悬疑',
    year: 2025,
    rating: 8.1,
    poster: 'https://readdy.ai/api/search-image?query=suspense%20movie%20poster%20chess%20board%20with%20human%20figures%20as%20pieces%20dramatic%20top-down%20lighting%20mysterious%20dark%20atmosphere%20cinematic%20film%20poster%20style%20intellectual%20thriller&width=600&height=900&seq=movie-15&orientation=portrait',
    description: '知名律师在一场看似普通的离婚案中，意外发现了背后隐藏的巨大商业阴谋。当他一步步深入调查时，身边的人开始一个接一个地"消失"，而所有的线索都指向了他最信任的合作伙伴。在这场猫鼠游戏中，每个人都可能是棋子，也每个人都可能是棋手。',
    director: '路阳',
    actors: ['邓超', '刘德华', '万茜', '周一围'],
    duration: '125分钟',
    releaseDate: '2025-09-15',
    isHot: false,
    isNew: false,
  },
  {
    id: '16',
    title: '大地之歌',
    category: 'juqing',
    categoryName: '剧情',
    year: 2025,
    rating: 8.9,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20drama%20movie%20poster%20farmer%20in%20golden%20wheat%20field%20at%20sunset%20traditional%20village%20in%20background%20warm%20earthy%20tones%20cinematic%20film%20poster%20style%20rural%20China%20aesthetic&width=600&height=900&seq=movie-16&orientation=portrait',
    description: '在中国西北的一个小村庄里，三代农民面对土地流转和城市化浪潮做出了不同的选择。老一辈固守着祖辈留下的土地，中年人渴望进城谋生，而年轻人则在传统与现代之间寻找平衡。影片用质朴的镜头语言，记录了一个村庄、一个时代和一个民族的命运变迁。',
    director: '李睿珺',
    actors: ['王景春', '咏梅', '黄轩', '海清'],
    duration: '130分钟',
    releaseDate: '2025-07-20',
    isHot: false,
    isNew: false,
  },
  {
    id: '17',
    title: '烈火英雄2',
    category: 'dongzuo',
    categoryName: '动作',
    year: 2026,
    rating: 8.6,
    poster: 'https://readdy.ai/api/search-image?query=action%20movie%20poster%20firefighter%20in%20burning%20building%20heroic%20pose%20intense%20flames%20dramatic%20lighting%20cinematic%20film%20poster%20style%20orange%20and%20red%20tones&width=600&height=900&seq=movie-17&orientation=portrait',
    description: '一场突如其来的化工厂大爆炸让整座城市陷入火海。消防队长江立伟带领队员们再次逆行而上，在连环爆炸和毒气泄漏的死亡威胁下，他们用血肉之躯筑起了守护城市的最后一道防线。每一次出发都可能是永别，但他们从未退缩。致敬每一位逆火而行的平凡英雄。',
    director: '陈国辉',
    actors: ['黄晓明', '杜江', '杨紫', '欧豪'],
    duration: '135分钟',
    releaseDate: '2026-07-15',
    isHot: true,
    isNew: true,
  },
  {
    id: '18',
    title: '美食大冒险',
    category: 'xiju',
    categoryName: '喜剧',
    year: 2025,
    rating: 7.6,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20food%20comedy%20movie%20poster%20chef%20surrounded%20by%20colorful%20dishes%20kitchen%20chaos%20steaming%20food%20warm%20lighting%20cinematic%20film%20poster%20style%20appetizing&width=600&height=900&seq=movie-18&orientation=portrait',
    description: '一个从没下过厨房的富二代，因为打赌被迫参加全国厨师大赛。在一群"奇葩"队友的帮助下，他不仅学会了做菜，还意外发现了中华美食背后蕴含的人生哲理。从手忙脚乱的厨房小白到过关斩将的黑马选手，这不仅是一场味蕾的狂欢，更是一段笑中带泪的成长之旅。',
    director: '许诚毅',
    actors: ['肖央', '谭卓', '大鹏', '柳岩'],
    duration: '108分钟',
    releaseDate: '2025-11-20',
    isHot: false,
    isNew: false,
  },
  {
    id: '19',
    title: '暗物质',
    category: 'kehuan',
    categoryName: '科幻',
    year: 2025,
    rating: 8.3,
    poster: 'https://readdy.ai/api/search-image?query=sci-fi%20movie%20poster%20dark%20matter%20particle%20physics%20laboratory%20glowing%20energy%20field%20scientist%20silhouette%20dramatic%20contrast%20cinematic%20film%20poster%20style%20mysterious%20scientific&width=600&height=900&seq=movie-19&orientation=portrait',
    description: '在一次地下实验室的粒子对撞实验中，科学家们意外创造出了一个肉眼不可见的"暗物质生命体"。它开始以人类无法理解的方式与这个世界互动，每次接触都会引发超乎想象的物理现象。当军方决定摧毁它时，研究团队的首席科学家却发现，这个生命体可能掌握着宇宙起源的终极奥秘。',
    director: '王壬',
    actors: ['吴彦祖', '汤唯', '冯绍峰', '张钧甯'],
    duration: '120分钟',
    releaseDate: '2025-05-18',
    isHot: false,
    isNew: false,
  },
  {
    id: '20',
    title: '约定',
    category: 'aiqing',
    categoryName: '爱情',
    year: 2025,
    rating: 8.0,
    poster: 'https://readdy.ai/api/search-image?query=romantic%20movie%20poster%20two%20people%20at%20train%20station%20platform%20sunset%20light%20nostalgic%20atmosphere%20cinematic%20film%20poster%20style%20warm%20vintage%20tones%20emotional&width=600&height=900&seq=movie-20&orientation=portrait',
    description: '一对恋人在火车站许下"十年之约"——如果十年后的今天彼此依然单身，就回到这里重聚。时光飞逝，十年间他们各自经历了人生的起起落落。当约定的日子终于到来，站台上的一切都已经变了模样，但有些东西，或许从未改变。关于承诺、等待和遗憾的都市爱情故事。',
    director: '薛晓路',
    actors: ['白百何', '彭于晏', '章子怡', '黄轩'],
    duration: '103分钟',
    releaseDate: '2025-02-14',
    isHot: false,
    isNew: false,
  },
];

export const getMoviesByCategory = (categorySlug: string): Movie[] => {
  if (categorySlug === 'all') return movies;
  return movies.filter((m) => m.category === categorySlug);
};

export const getMovieById = (id: string): Movie | undefined => {
  return movies.find((m) => m.id === id);
};

export const getHotMovies = (): Movie[] => {
  return movies.filter((m) => m.isHot);
};

export const getNewMovies = (): Movie[] => {
  return movies.filter((m) => m.isNew);
};

export const getRelatedMovies = (movieId: string, limit: number = 4): Movie[] => {
  const movie = getMovieById(movieId);
  if (!movie) return [];
  return movies
    .filter((m) => m.id !== movieId && m.category === movie.category)
    .slice(0, limit);
};